import {HoistModel, managed} from '@xh/hoist/core';
import {DashContainerModel} from '@xh/hoist/desktop/cmp/dash';
import {Icon} from '@xh/hoist/icon';
import {ratesWidget} from './widgets/treasury/RatesWidget';
import {topTradingWidget} from './widgets/topTrading/TopTradingWidget';
import {newsWidget} from './widgets/news/NewsWidget';
import {ecoIndicatorWidget} from './widgets/economicIndicator/EcoIndicatorWidget';
import {economicCalendarWidget} from './widgets/economicCalendar/EconomicCalendarWidget';
import {volSurfaceWidget} from './widgets/volSurface/VolSurfaceWidget';
import {worldHeatmapWidget} from './widgets/worldHeatmap/WorldHeatmapWidget';
import {fearAndGreedWidget} from './widgets/fearAndGreed/FearAndGreedWidget';
import {quoteWidget} from './widgets/quote/QuoteWidget';
import {lineColumnsIcon, percentageIcon} from '../../../core/Icons';

export class MarketsTabModel extends HoistModel {
    @managed dashContainerModel: DashContainerModel = this.createDashModel();

    private createDashModel(): DashContainerModel {
        return new DashContainerModel({
            persistWith: {prefKey: 'marketsTabState'},
            showMenuButton: true,
            renameLocked: false,
            viewSpecs: [
                {
                    id: 'treasuryRates',
                    title: 'Treasury Rates',
                    icon: percentageIcon(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: ratesWidget
                },
                {
                    id: 'topTrading',
                    title: 'Top Trading',
                    icon: lineColumnsIcon(),
                    unique: false,
                    allowRemove: true,
                    allowAdd: true,
                    content: topTradingWidget
                },
                {
                    id: 'news',
                    title: 'News',
                    icon: Icon.bolt(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: newsWidget
                },
                {
                    id: 'economicIndicator',
                    title: 'Economic Indicator',
                    icon: Icon.balanceScale(),
                    unique: false,
                    allowRemove: true,
                    allowAdd: true,
                    content: ecoIndicatorWidget
                },
                {
                    id: 'economicCalendar',
                    title: 'Economic Calendar',
                    icon: Icon.calendar(),
                    unique: false,
                    allowRemove: true,
                    allowAdd: true,
                    content: economicCalendarWidget
                },
                {
                    id: 'volSurface',
                    title: 'Volatility',
                    icon: Icon.cube(),
                    unique: false,
                    allowRemove: true,
                    allowAdd: true,
                    content: volSurfaceWidget
                },
                {
                    id: 'worldHeatmap',
                    title: 'World Heatmap',
                    icon: Icon.globe(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: worldHeatmapWidget
                },
                {
                    id: 'fearAndGreed',
                    title: 'Fear & Greed',
                    icon: Icon.gauge(),
                    unique: true,
                    allowRemove: true,
                    allowAdd: true,
                    content: fearAndGreedWidget
                },
                {
                    id: 'quotes',
                    title: 'Quotes',
                    icon: Icon.bolt(),
                    unique: false,
                    allowRemove: true,
                    allowAdd: true,
                    content: quoteWidget
                }
            ],
            initialState: [
                {
                    type: 'row',
                    width: 100,
                    content: [{type: 'view', id: 'treasuryRates'}]
                }
            ]
        });
    }
}
